import { api } from "./api";

export class ConfigService {
  static getConfig() {
    return api.get("/stix/config");
  }
}
